import { render, staticRenderFns } from "./longcard.vue?vue&type=template&id=887c1ea0&scoped=true&"
import script from "./longcard.vue?vue&type=script&lang=js&"
export * from "./longcard.vue?vue&type=script&lang=js&"
import style0 from "./longcard.vue?vue&type=style&index=0&id=887c1ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887c1ea0",
  null
  
)

export default component.exports